import { render, staticRenderFns } from "./OrderProductsTable.vue?vue&type=template&id=233715ce&"
import script from "./OrderProductsTable.vue?vue&type=script&lang=js&"
export * from "./OrderProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductsTable.vue?vue&type=style&index=0&id=233715ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports